// core
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

// services
import {CustomHttp} from '../../core/http-custom/http-custom.service';

// models
import {Profile} from '../models/profile.model';
import {ImageModel} from 'app/shared/models/image.model';

@Injectable()
export class UpdateProfileService {

  constructor(private _http: CustomHttp) {
  }

  public fetchProfile(): Observable<Profile> {
    return this._http.get(`/apps/umng/user/me/profile`);
  }

  public updateUserProfile(userProfile: Profile, upload?: ImageModel, removeAvatar?: boolean): Observable<Profile> {
    return this._http.put(`/apps/umng/user/me/profile`,
      {
        userProfile: userProfile,
        upload: upload,
        removeAvatar: removeAvatar
      },
      null
    );

  }

  public deleteProfile(): Observable<any> {
    return this._http.delete(`/apps/umng/user/me/profile`);
  }

  public getCustomerLogo(): Observable<ImageModel> {
    return this._http.get(`/apps/umng/user/me/customer/logo`);
  }

  public getProfilePicture(): Observable<ImageModel> {
    return this._http.get(`/apps/umng/user/me/profile/picture`);
  }

  public resendNewsletterSubscriptionLink() {
    return this._http.get(`/apps/umng/api/user/resend-newsletter-subscription-link`);
  }

  public getCountries() {
    return this._http.get(`/apps/umng/api/usermng/countries`);
  }
}
